import React from 'react';

class Aide extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      
    };
  }

  componentDidMount() {
    //document.getElementById('pushChatWidgetStart').style.display = 'block';
    //document.getElementById('pushChatWidget').style.display = 'block';
  }

  render() {

    return (
      <div>
        <style>{`
        #pushChatWidgetStart, #pushChatWidget {
          display: block;
        }
        `}</style>
      </div>
    );

  }

}

export default Aide;



/** WEBPACK FOOTER **
 ** ./src/components/HomePageNew/Aide.js
 **/